<template>
    <div class="scroll">
        <div class="inner">
            <p>{{ $i18nUtil.trans("message.PrivacyPolicy.001") }}</p>
            <p>{{ $i18nUtil.trans("message.PrivacyPolicy.002", {url: $i18nUtil.trans("message.cowork.url","https://cp.hanwha.com")}) }}</p>
            <p><b>{{ $i18nUtil.trans("message.PrivacyPolicy.003") }}</b></p>
            <p class="pdl8" v-html="$i18nUtil.trans('message.PrivacyPolicy.004')"></p>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.005") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.006") }}</li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.007") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.008") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.009") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.010") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.011", {url: $i18nUtil.trans("message.cowork.url","https://cp.hanwha.com")}) }}</li>
                <!-- <li>
                    <table>
                        <colgroup>
                            <col width="20%">
                            <col width="80%">
                        </colgroup>
                        <tr>
                            <th>구분</th>
                            <th>이용 목적</th>
                        </tr>
                        <tr>
                            <td>업무공유시스템</td>
                            <td>- 회원제 서비스 이용에 따른 협력사 임직원 본인확인, 개인식별<br>
                                - 불량회원의 부정이용 방지와 비인가 사용 방지<br>
                                - 가입의사 확인, 가입 및 가입횟수 제한<br>
                                - 고객불만 접수 및 처리, 분쟁조정을 위한 기록보존<br>
                                - 고지사항 전달
                            </td>
                        </tr>
                    </table>
                </li> -->
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.012") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.013") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.014") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.015") }}</li>
                <li>
                    <table>
                        <colgroup>
                            <col width="15%">
                            <col width="85%">
                        </colgroup>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.016')">
                            <!-- <th>유형</th><th>수집 항목</th> -->
                        </tr>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.017')">
                            <!-- <td class="tac">필수</td><td>사용자아이디, 비밀번호, 소속회사명, 이메일, 휴대폰번호</td> -->
                        </tr>
                    </table>
                </li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.018") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.019") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.020", {url: $i18nUtil.trans("message.cowork.url","https://cp.hanwha.com")}) }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.021") }}</li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.022") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.023") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.024") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.025") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.026") }}</li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.027") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.028") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.029") }}</li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.030") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.031") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.032") }}</li>
                    </ul>
                </li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.033") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.034") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.035") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.036") }}</li>
                    </ul>
                </li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.037") }}</li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.038") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.039") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.040") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.041") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.042") }}</li>
                        <li class="mgl8">{{ $i18nUtil.trans("message.PrivacyPolicy.043") }}</li>
                        <li class="mgl8">{{ $i18nUtil.trans("message.PrivacyPolicy.044") }}</li>
                    </ul>
                </li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.045") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.046") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.047") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.048") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.049") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.050") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.051") }}</li>
                    </ul>
                </li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.052") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.053") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.054") }}</li>
                        <li class="mgl8">{{ $i18nUtil.trans("message.PrivacyPolicy.055") }}</li>
                        <li class="mgl8">{{ $i18nUtil.trans("message.PrivacyPolicy.056") }}</li>
                        <li class="mgl8">{{ $i18nUtil.trans("message.PrivacyPolicy.057") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.058") }}</li>
                    </ul>
                </li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.059") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.060") }}</li>
                    </ul>
                </li>
                <!-- <li>
                    <table>
                        <colgroup>
                            <col width="15%">
                            <col width="35%">
                            <col width="15%">
                            <col width="35%">
                        </colgroup>
                        <tr>
                            <th colspan="2">개인정보관리 책임자</th>
                            <th colspan="2">개인정보관리 담당자</th>
                        </tr>
                        <tr>
                            <th>담당부서</th>
                            <td>SharedService 담당</td>
                            <th>담당부서</th>
                            <td>PI팀</td>
                        </tr>
                        <tr>
                            <th>성명/직급</th>
                            <td>신동일 상무</td>
                            <th>성명/직급</th>
                            <td>이현우 차장</td>
                        </tr>
                        <tr>
                            <th>전화번호</th>
                            <td>02-6313-3114</td>
                            <th>전화번호</th>
                            <td>02-6313-3114</td>
                        </tr>
                        <tr>
                            <th>E-Mail</th>
                            <td>privacy@hanwha.com</td>
                            <th>E-Mail</th>
                            <td>privacy@hanwha.com</td>
                        </tr>
                    </table>
                </li>                 -->
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.061") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.062") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.063") }}</li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.064") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.065") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.066") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.067") }}</li>
                    </ul>
                </li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.068") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.069") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.070") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.071") }}</li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.072") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.073") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.074") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.075") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.076") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.077") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.078") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.079") }}</li>
                    </ul>
                </li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.080") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.081") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.082") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.083") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.084") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.085") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.086") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.087") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.088") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.089") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.090") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.091") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.092") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.093") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.094") }}</li>
                    </ul>
                </li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.095") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.096") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.097") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.098") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.099") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.100") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.101") }}</li>
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.102") }}</li>
                    </ul>
                </li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.103") }}</li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.104") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.105") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.106") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.107") }}</li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.108") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.109") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.110") }}</li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.111") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.112") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.113") }}</li>
                <li>
                    <ul class="s_ul">
                        <li>{{ $i18nUtil.trans("message.PrivacyPolicy.114") }}</li>
                    </ul>
                </li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.115") }}</li>
                <li>
                    <table>
                        <colgroup>
                            <col width="30%">
                            <col width="30%">
                            <col width="40%">
                        </colgroup>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.116')">
                            <!-- <th>기관</th>
                            <th>전화번호</th>
                            <th>홈페이지</th> -->
                        </tr>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.117')">
                            <!-- <td>개인정보침해신고센터</td>
                            <td>(국번없이)118</td>
                            <td>http://privacy.kisa.or.kr</td> -->
                        </tr>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.118')">
                            <!-- <td>개인정보 분쟁조정위원회</td>
                            <td>(국번없이)1833-6972</td>
                            <td>http://kopico.go.kr</td> -->
                        </tr>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.119')">
                            <!-- <td>대검찰청 사이버수사과</td>
                            <td>(국번없이)1301</td>
                            <td>http://spo.go.kr</td> -->
                        </tr>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.120')">
                            <!-- <td>경찰청 사이버안전국</td>
                            <td>(국번없이)182</td>
                            <td>http://cyberbureau.police.go.kr</td> -->
                        </tr>
                    </table>
                </li>
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.121") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.122") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.123") }}</li>
                <li>
                    <table>
                        <colgroup>
                            <col width="15%">
                            <col width="35%">
                            <col width="15%">
                            <col width="35%">
                        </colgroup>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.124')">
                            <!-- <th colspan="2">개인정보관리 책임자</th>
                            <th colspan="2">개인정보관리 담당자</th> -->
                        </tr>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.125')">
                            <!-- <th>담당부서</th>
                            <td>SharedService담당</td>
                            <th>담당부서</th>
                            <td>PI팀</td> -->
                        </tr>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.126')">
                            <!-- <th>성명/직급</th>
                            <td>신동일 상무</td>
                            <th>성명/직급</th>
                            <td>이재환 과장</td> -->
                        </tr>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.127')">
                            <!-- <th>전화번호</th>
                            <td>02-6313-3114</td>
                            <th>전화번호</th>
                            <td>02-6313-3114</td> -->
                        </tr>
                        <tr v-html="$i18nUtil.trans('message.PrivacyPolicy.128')">
                            <!-- <th>E-Mail</th>
                            <td>privacy@hanwha.com</td>
                            <th>E-Mail</th>
                            <td>privacy@hanwha.com</td> -->
                        </tr>
                    </table>
                </li>                                
            </ul>
            <ul>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.129") }}</li>
                <li>{{ $i18nUtil.trans("message.PrivacyPolicy.130", {url: $i18nUtil.trans("message.cowork.url","https://cp.hanwha.com")}) }}</li>
            </ul>
        </div>
    </div>
</template>
<script>

export default {
    components: {
    },
    data() {
        return {
            tenantId: localStorage.getItem("tenantId"), 
        };
    },
    methods: {  },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/join/modal/PrivacyPolicy.vue